import React, { Component } from 'react';
import { Layout, Menu, Breadcrumb, Affix, Avatar, Popover, Button, Icon } from 'antd';
import { Row, Col } from 'react-flexbox-grid';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import UserMenu from './UserMenu';
import _ from 'lodash';
import LanguageSwitcher from '../../LanguageSwitcher';

const { Header } = Layout;

class MainHeader extends Component {
	state = { menuClicked: false, userMenuVisible: false };

	constructor(props) {
		super(props);
	}

	render() {
		const { i18n } = this.props;
		const changeLanguage = lng => {
			i18n.changeLanguage(lng);
		};

		const username = _.get(this.props.user, 'username');
		return (
			<div>
				<MediaQuery query="(max-width: 767px)">
					<Affix>
						<Header>
							<Row>
								<Col xs={12}>
									<Row middle="xs" between="md">
										<Col xs={2} start="xs">
											<div className="trigger-button">
												<Icon type="bars" ref="trigger" onClick={this.onMenuClick.bind(this)} style={{ color: 'white' }} />
											</div>
										</Col>
										<Col xs={8} center="xs">
											<Link to="/">
												<img src={`${process.env.PUBLIC_URL}/logo.png`} width="100%" />
											</Link>
										</Col>
										<Col xs={2} end="xs">
											<span className="avatar-box">
												<Popover
													placement="bottomRight"
													title={username}
													ref={over => (this.popOver = over)}
													content={this.getPopoverContent()}
													trigger="click"
													visible={this.state.userMenuVisible}
													onVisibleChange={this.handleVisibleChange.bind(this)}
												>
													{this.getAvatar()}
												</Popover>
											</span>
										</Col>
									</Row>
								</Col>
							</Row>
						</Header>
					</Affix>
				</MediaQuery>
				<MediaQuery query="(min-width: 768px)">
					<Affix>
						<Header>
							<Row>
								<Col xs={12}>
									<Row middle="xs" between="xs">
										<Col xs={1} start="xs">
											<div className="trigger-button">
												<Icon type="bars" ref="trigger" />
											</div>
										</Col>
										<Col xs={3} xsOffset={8} md={7} mdOffset={4} middle="xs" className="end-xs">
											<LanguageSwitcher />
											<span>Hi {username}!&nbsp;&nbsp;&nbsp;</span>
											<span className="avatar-box">
												<Popover
													placement="bottomRight"
													title={username}
													ref={over => (this.popOver = over)}
													content={this.getPopoverContent()}
													trigger="click"
													visible={this.state.userMenuVisible}
													onVisibleChange={this.handleVisibleChange.bind(this)}
												>
													{this.getAvatar()}
												</Popover>
											</span>
										</Col>
									</Row>
								</Col>
							</Row>
						</Header>
					</Affix>
				</MediaQuery>
			</div>
		);
	}

	handleVisibleChange(userMenuVisible) {
		this.setState({ userMenuVisible });
	}

	onMenuClick() {
		this.setState({ userMenuVisible: false });
		this.props.onMenuClick(!this.props.menuClicked);
	}

	onLogout() {
		if (this.props.onLogout) {
			this.props.onLogout(null);
		}
	}

	onLogouts(){
		this.props.onLogouts()
	}

	getPopoverContent() {
		return <UserMenu user={this.props.user} googleService={this.props.googleService} onClick={this.onMenuClick.bind(this)} onLogouts={this.onLogouts.bind(this)}/>;	}

	getAvatar() {
		let avatar = _.get(this.props.user, 'avatar');
		let props = avatar ? { src: avatar } : { icon: 'user' };
		return <Avatar className="avatar" {...props} />;
	}
}
export default MainHeader;



// WEBPACK FOOTER //
// ./src/components/layouts/MainHeader.js